import dayjs from 'dayjs'

export const PrescriptionsTableColumns = [
  {
    title: 'First Name',
    dataIndex: 'patient_first_name',
    key: 'patient_first_name',
    type: 'text',
    className: 'table-col-min-width-md',
    editable: false,
    sorter: true,
  },
  {
    title: 'Last Name',
    dataIndex: 'patient_last_name',
    key: 'patient_last_name',
    type: 'text',
    className: 'table-col-min-width-md',
    editable: false,
    sorter: true,
  },
  {
    title: 'Pharmacy Name',
    dataIndex: 'pharmacy_name',
    key: 'pharmacy_name',
    type: 'text',
    className: 'table-col-min-width-md',
    editable: false,
    sorter: true,
  },
  {
    title: 'Pharmacy Phone Number',
    dataIndex: 'pharmacy_phone_number',
    key: 'pat_phone',
    type: 'text',
    editable: false,
    sorter: true,
  },
  {
    title: 'Created At',
    dataIndex: 'created_at',
    key: 'created_at',
    type: 'text',
    editable: false,
    sorter: true,
    render: (created_at: string) => dayjs(created_at).format("ddd, MMM DD 'YY"),
  },
]
